import { Spacer } from '@kizen/kds/Spacer';
import { Typography } from '@kizen/kds/Typography';
import { IconWithTooltip } from '__pages/Common/components/LinkWithIconTooltip/IconWithTooltip';
import { colorsPrimary, colorsSecondary } from 'app/colors';
import PercentageBar from 'components/PercentageBar';
import { useTranslation } from 'react-i18next';

type StatisticRowProps = {
  percentage: number;
  used: number;
  limit: number;
  color?: string;
  barWidth: number;
  label: string;
  info?: string;
};

export const StatisticRow = (props: StatisticRowProps) => {
  const { percentage, used, limit, color, barWidth, label, info } = props;
  const { t } = useTranslation();

  let derivedColor = color;
  if (!color) {
    if (percentage > 100) {
      derivedColor = colorsSecondary.red.dark;
    } else if (percentage > 50) {
      derivedColor = colorsPrimary.green.dark;
    } else {
      derivedColor = colorsPrimary.green.dark;
    }
  }

  return (
    <div>
      <div
        className="max-w-[var(--bar-width)] flex justify-between"
        style={
          {
            '--bar-width': `${barWidth}px`,
          } as any
        }
      >
        <div className="flex items-center gap-x-5">
          <Typography>{label}</Typography>
          {info ? <IconWithTooltip label={info} /> : null}
        </div>
        <Typography>
          {used.toLocaleString()}/
          {limit === Infinity ? t('unlimited') : limit.toLocaleString()}
        </Typography>
      </div>
      <Spacer size={10} />
      <div className="flex gap-x-5 w-full">
        <PercentageBar
          responsive
          percentage={percentage}
          width={barWidth}
          primaryColor={derivedColor}
        />
      </div>
    </div>
  );
};
